export default __webpack_public_path__ + "static/media/ic_more.adbc57c1.svg";